<template>
<section>
    <div class="wrap">

        <!-- <ul class="my_review_ul">
            <li :class="{ cho : (dtype == TABLE_TYPE.SC.id) }" @click="tab(TABLE_TYPE.SC.id)"><a>SC</a></li>
            <li :class="{ cho : (dtype == TABLE_TYPE.SHOP.id) }" @click="tab(TABLE_TYPE.SHOP.id)"><a>전시장</a></li>
            <li :class="{ cho : (dtype == TABLE_TYPE.TRIM.id) }" @click="tab(TABLE_TYPE.TRIM.id)"><a >차량</a></li>
        </ul> -->

        <div class="reservation_type_ul">
            <a :class="{ now : (dtype == TABLE_TYPE.SC.id) }" @click="tab(TABLE_TYPE.SC.id)">SC</a>
            <a :class="{ now : (dtype == TABLE_TYPE.SHOP.id) }" @click="tab(TABLE_TYPE.SHOP.id)">전시장</a>
            <a :class="{ now : (dtype == TABLE_TYPE.TRIM.id) }" @click="tab(TABLE_TYPE.TRIM.id)">차량</a>
        </div>

        <div class="title_box" style="margin-top: 20px;">

            <h4 class="title">후기<span>{{reviewCount}}</span></h4>

            <select class="nojs_select" v-model="score">
                <option value="">전체</option>
                <template v-for="(important, index) in REVIEW_SCORE">
                    <option :value="`${important.id}`" :key="index" >{{important.title}}</option>
                </template>
            </select>
        </div>

        <!-- <ul class="my_review_list">
            <none-data title="작성된 리뷰가 없습니다." v-if="reviewItemsFilter.length == 0" />
            <li v-for="review in reviewItemsFilter" :key="`review-find-list-item-${review.id}`" @click="clickReview(review.id)">
                <img :src="scoreImg(review.score)"/>
                <div>
                    <dl>
                        <template v-if="review.dtype == TABLE_TYPE.SC.id">
                            <dt>{{review.scName}} 컨설턴트<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <span>{{review.shopName}}</span>
                                <span>{{review.brandName}} {{review.dealerName}}</span>
                            </dd>
                        </template>
                        <template v-if="review.dtype == TABLE_TYPE.SHOP.id">
                            <dt>{{review.shopName}}<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <span>{{review.brandName}} {{review.dealerName}}</span>
                            </dd>
                        </template>
                        <template v-if="review.dtype == TABLE_TYPE.TRIM.id">
                            <dt>{{review.trimName}}<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <span>{{review.shopName}}</span>
                                <span>{{review.brandName}} {{review.dealerName}}</span>
                            </dd>
                        </template>
                        
                        <dd class="tag">
                            <span>
                                {{detailScoreArr(review.detailScore)}}
                            </span>
                        </dd>

                        <dd :class="['contents', { 'reviewHide': review.id != showReviewId }]">{{review.content}}</dd>
                    </dl>
                </div>
            </li>
        </ul> -->
        <ul class="my_review_list" v-if="reviewItemsFilter.length == 0" >
            <none-data title="작성된 리뷰가 없습니다." />
        </ul>

        <ul class="my_review_list" style="margin-bottom:20px;" 
            v-else 
            v-for="review in reviewItemsFilter" 
            :key="`review-find-list-item-${review.id}`" @click="clickReview(review.id)"
        >
            <li>
                <!--<img :src="scoreImg(review.score)"/>-->
                <div>
                    <dl>
                        <template v-if="review.dtype == TABLE_TYPE.SC.id">
                            <dt>{{review.scName}} 컨설턴트<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <p>
                                    <span>{{review.shopName}}</span>
                                    <span>{{review.brandName}} {{review.dealerName}}</span>
                                </p>
                                <div class="star_box2">
                                    <star-rating
                                        v-model="review.rating"
                                        :increment="0.1"
                                        :max-rating="5"
                                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                        inactive-color="#E9EAEC"
                                        active-color="#FFE78A"
                                        :star-size="15"
                                        text-class = ''
                                        read-only>
                                    </star-rating>
                                </div>
                            </dd>
                        </template>
                        <template v-if="review.dtype == TABLE_TYPE.SHOP.id">
                            <dt>{{review.shopName}}<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <span>{{review.brandName}} {{review.dealerName}}</span>
                                <div class="star_box2">
                                    <star-rating
                                        v-model="review.rating"
                                        :increment="0.1"
                                        :max-rating="5"
                                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                        inactive-color="#E9EAEC"
                                        active-color="#FFE78A"
                                        :star-size="15"
                                        text-class = ''
                                        read-only>
                                    </star-rating>
                                </div>
                            </dd>
                        </template>
                        <template v-if="review.dtype == TABLE_TYPE.TRIM.id">
                            <dt>{{review.trimName}}<span>{{getCreateDtFormat(review.createDt)}}</span></dt>
                            <dd class="info">
                                <p>
                                    <span>{{review.shopName}}</span>
                                    <span>{{review.brandName}} {{review.dealerName}}</span>
                                </p>
                                <div class="star_box2">
                                    <star-rating
                                        v-model="review.rating"
                                        :increment="0.1"
                                        :max-rating="5"
                                        :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
                                        inactive-color="#E9EAEC"
                                        active-color="#FFE78A"
                                        :star-size="15"
                                        text-class = ''
                                        read-only>
                                    </star-rating>
                                </div>
                            </dd>
                        </template>
                        
                        <dd class="tag">
                            <span>
                                {{detailScoreArr(review.detailScore)}}
                            </span>
                        </dd>

                        <!-- { 'reviewHide': review.id != showReviewId } -->
                        <dd v-if="review.content" :class="['contents']">{{review.content}}</dd>
                        <dd v-else :class="['contents']">{{review.content}}</dd>
                    </dl>
                </div>
            </li>
        </ul>
    </div>
</section>
</template>

<script>



import $ from 'jquery';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import StarRating  from "vue-star-rating";
export default {
    name:'MyReview',
    components: { 
            StarRating
        },
    async created () {
        this.$store.state.headerTitle = '내가 남긴 후기';
        this.$store.state.review.filters.userId = this.$store.state.auth.item.id;
        this.dtype = this.TABLE_TYPE.SC.id;
        await this.getReviewList();
        this.$store.commit('SHOW_ONLOAD');
    },
    
    watch: {
        dtype() {
            this.score = '';
            this.getReviewList();
        }
    },
    data() {
        return {
            score: '',
            dtype: '',
            reviewCount:0,
            showReviewId: 0,
        }
    },    
    computed: {
        ...mapState({
            ReviewItems : state => state.review.items,
            TABLE_TYPE : state => state.codeDictionary.items.TABLE_TYPE,
            REVIEW_SCORE: state => state.codeDictionary.items.REVIEW_SCORE,
            REVIEW_SC_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SC_DETAIL_SCORE,
            REVIEW_SHOP_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_SHOP_DETAIL_SCORE,
            REVIEW_TRIM_DETAIL_SCORE: state => state.codeDictionary.items.REVIEW_TRIM_DETAIL_SCORE,
        }),
        routeName() {
            return this.$route.name;
        },
        reviewItemsFilter(){
            return this.ReviewItems.filter(e => (this.score) ? (e.score == this.score) : true);
        },
    },
    methods: {
        tab(tableType){
            this.dtype = tableType;
        },
        clickReview(reviewId) {
            if(this.showReviewId == reviewId) this.showReviewId = 0;
            else this.showReviewId = reviewId;
        },
        scoreImg(score) {
            let url = '';
            
            if(score == this.REVIEW_SCORE.BAD.id)
                url = this.$store.state.resource.imgReviewBad;
            if(score == this.REVIEW_SCORE.NORMAL.id)
                url = this.$store.state.resource.imgReviewNormal;
            if(score == this.REVIEW_SCORE.GOOD.id)
                url = this.$store.state.resource.imgReviewGood;

            return url;
        },
        detailScoreArr(detailScore) {
            let dScore = '';

            let reviewType = '';
            if(this.dtype == this.TABLE_TYPE.SC.id)
                reviewType = this.REVIEW_SC_DETAIL_SCORE;
            if(this.dtype == this.TABLE_TYPE.SHOP.id)
                reviewType = this.REVIEW_SHOP_DETAIL_SCORE;
            if(this.dtype == this.TABLE_TYPE.TRIM.id)
                reviewType = this.REVIEW_TRIM_DETAIL_SCORE;

            for(let key in reviewType) {
                if(detailScore.includes(reviewType[key].id))
                    dScore += '#' + reviewType[key].title + " ";
            }

            return dScore;
        },

        getCreateDtFormat(create_dt) {
            return dayjs(create_dt).format("YYYY-MM-DD");
        },

        async getReviewList(){

            await this.$store.dispatch('GET_REVIEW_LIST', {
                dtype:this.dtype
            })
            .then((data)=>{
                this.setReviewContent();
                this.reviewCount = data.totalElements;
            });

            this.$store.commit('SHOW_ONLOAD');
        },

        setReviewContent() {

            $('.my_review_list .contents').each(function(){
                if($(this).height() >= 28) {
                    $(this).addClass('reviewHide')
                }
            })

            $('.my_review_list .contents').click(function(){
            
                if($(this).hasClass("reviewHide")){

                    $(this).removeClass("reviewHide")

                } else if($(this).height() >= 28) {

                    $(this).addClass("reviewHide")
                    
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>

</style>